/**
 * @voltxampere/web — Tool category builtin commands (Sprint 22 C3)
 *
 * 6 canvas-mode toggle commands. The Sprint 11 `selectedTool` signal
 * accepts "select" / "wire" / "erase"; the wider canvas roadmap adds
 * "stamp", "pan", "probe", "text" — these palette commands surface
 * future modes today as discoverable affordances even when the
 * underlying canvas mode is a Sprint 23+ landing.
 *
 * Copyright © 2026 360 Studio
 * Proprietary — All rights reserved.
 */

import type { Command } from "../types.js";
import { selectedTool } from "../../store/ui.js";

const noop = (): void => {
  /* Sprint 22 stub for canvas modes pending S23 wire-up. */
};

export const TOOL_COMMANDS: readonly Command[] = [
  {
    id: "tool.select",
    titleKey: "command.tool.select",
    descriptionKey: "command.tool.select.desc",
    category: "tool",
    shortcut: "V",
    execute: () => {
      selectedTool.value = "select";
    },
  },
  {
    id: "tool.wire",
    titleKey: "command.tool.wire",
    descriptionKey: "command.tool.wire.desc",
    category: "tool",
    shortcut: "W",
    execute: () => {
      selectedTool.value = "wire";
    },
  },
  {
    id: "tool.stamp",
    titleKey: "command.tool.stamp",
    descriptionKey: "command.tool.stamp.desc",
    category: "tool",
    execute: noop, // selectedTool union is "select"|"wire"|"erase" today; stamp lands with S23 widened union
  },
  {
    id: "tool.pan",
    titleKey: "command.tool.pan",
    category: "tool",
    shortcut: "Space",
    execute: noop,
  },
  {
    id: "tool.probe",
    titleKey: "command.tool.probe",
    descriptionKey: "command.tool.probe.desc",
    category: "tool",
    shortcut: "P",
    execute: noop,
  },
  {
    id: "tool.text",
    titleKey: "command.tool.text",
    category: "tool",
    shortcut: "T",
    execute: noop, // Sprint 23+ text annotation tool
  },
];
